module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.5bac0bfc.svg";